/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "../../Dashboard/AdmDashboard/Dashboard.css";
import { BiHomeAlt } from "react-icons/bi";
import {
  MdDelete,
  MdOutlineModeEdit,
  MdOutlinePendingActions,
  MdSearch,
} from "react-icons/md";
import { TbNotes } from "react-icons/tb";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaCalendarDays } from "react-icons/fa6";
import { BsPersonRaisedHand } from "react-icons/bs";
import axios from "axios";
import {
  Apiurl,
  GetToken,
  RemoveUserSession,
  formatNoOfDays,
} from "../../../Utils/utils";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Loader from "../../loader/loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";

const AdmDashboard = () => {
  const [showModalNew, setShowModalNew] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [attendanceData, setAttendanceData] = useState([]);
  const [pendingLeavesData, setPendingLeavesData] = useState("");
  const [leaveRequest, setLeaveRequest] = useState([]);
  const [Thisyeardata, setThisyeardata] = useState("");
  const [deleteClickable, setDeleteClickable] = useState("");
  const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState([]);
  const [expandedReasonIndex, setExpandedReasonIndex] = useState({});
  const LoginToken = GetToken();
  const [searchFilter, setSearchFilter] = useState("LeaveTypes");
  const [userTodaysAttendance, setUserTodaysAttendance] = useState();
  const navigate = useNavigate();

  const handleDataSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();

    if (!searchTerm) {
      setLeaveRequest(leaveRequestDuplicate);
      return;
    }

    const filteredData = leaveRequestDuplicate.filter((item) => {
      if (searchFilter === "LeaveTypes") {
        return item?.LeaveTypes?.Name?.toLowerCase()?.includes(searchTerm);
      }

      if (searchFilter === "Status") {
        return item?.Status?.toLowerCase()?.includes(searchTerm);
      }

      return false;
    });

    setLeaveRequest(filteredData);
  };

  const toggleReadMore = (index) => {
    setExpandedReasonIndex((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const getShortText = (text, limit = 80) => {
    if (!text) return "-";
    if (text.length <= limit) return text;
    return `${text.slice(0, limit)}...`;
  };

  const addAMPM = (timeString) => {
    const time = new Date(`1970-01-01T${timeString}`);
    if (isNaN(time.getTime())) {
      return "";
    }
    const options = { hour: "numeric", minute: "numeric", hour12: true };
    return time.toLocaleTimeString("en-US", options);
  };

  const getStatusClassName = (status) => {
    if (status === "Cancelled") {
      return "EMP-Leaves-table-Pending-button";
    }
    if (status === "RejectedByHR" || status === "RejectedByAdmin") {
      return "EMP-Leaves-table-Rejected-button";
    }
    if (
      status === "ApprovedByHR" ||
      status === "YetToBeApprovedByHR" ||
      status === "YetToBeApprovedByAdmin" ||
      status === "ApprovedByAdmin"
    ) {
      return "EMP-YetToBeApprovedByTeamLead-button";
    }
    return "EMP-Leaves-table-Approved-button";
  };

  const timeINString = userTodaysAttendance?.InTime || "";
  const formattedINTime = addAMPM(timeINString);

  const TodaysAttendance = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetTodayAttendanceEmployee`,
    };
    axios(option)
      .then((response) => {
        const data = JSON.parse(response?.data?.data);
        setUserTodaysAttendance(data);
        setLoading(false);
      })
      .catch(() => {});
  };

  useEffect(() => {
    TodaysAttendance();
  }, []);

  const AttendanceAll = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetToday'sAttendance`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setAttendanceData(data?.Data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const CurrentYearLeaves = () => {
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/CurrentYearLeaves`,
    };
    axios(option)
      .then((response) => {
        const data = response?.data?.data;
        setThisyeardata(data);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }
      });
  };

  useEffect(() => {
    CurrentYearLeaves();
  }, []);

  const handleAttendanceSearch = () => {
    setLoading(true);
    const LoginToken = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Leave/TotalLeaves`,
    };
    axios(option)
      .then((e) => {
        const data = JSON.parse(e?.data?.data);
        setLeaveRequest(data);
        setLeaveRequestDuplicate(data);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");

        if (error?.response?.status === 401) {
          toast.error("Your session has expired");
          RemoveUserSession();
          navigate("/", { replace: true });
        }

        setLoading(false);
      });
  };

  useEffect(() => {
    handleAttendanceSearch();
  }, []);

  const PendingLeaves = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/PendingLeaves`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setPendingLeavesData(data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    AttendanceAll();
    PendingLeaves();
  }, []);

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const handleLeaveDelete = (item) => {
    setDeleteClickable(item);
    setShowModalNew(true);
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <section
          className={
            showSidebar
              ? "addmin-dashboard-main-container"
              : "addmin-dashboard-main-container-new"
          }
        >
          <div className="all-icons">
            <div>
              <p className="DASHBOARD-MAIN-HEADING">Dashboard</p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p>Home</p>
              <MdKeyboardArrowRight />
              <p>Dashboard</p>
            </div>
          </div>

          <div className="dashboard-allcards-flex-container">
            <div className="admin-dashboard-card dashboard-common-card dashboard-small-card">
              <div className="dashboard-img-icon">
                <BsPersonRaisedHand />
              </div>
              <p className="dashboard-1st-card-heading">Today's Log-in Time</p>
              <p className="dashboard-number-heading">
                {formattedINTime ? formattedINTime.toLocaleString() : "-"}
              </p>
            </div>

            <div className="dashboard-card-second-last dashboard-common-card dashboard-small-card">
              <div className="dashboard-img-icon">
                <TbNotes />
              </div>
              <p className="dashboard-1st-card-heading">Leaves since 1 jan</p>
              <p className="dashboard-number-heading">
                {Thisyeardata !== "" && Thisyeardata !== null
                  ? Number(Thisyeardata)
                  : "-"}
                /18
              </p>
            </div>

            <div className="dashboard-SECOND-card dashboard-common-card dashboard-small-card">
              <div className="FaCalendarDays-dashboard-img-icon">
                <FaCalendarDays />
              </div>
              <p className="dashboard-1st-card-heading">
                Total no of leaves (Today)
              </p>
              <p className="dashboard-number-heading">
                {attendanceData?.Leave ? attendanceData?.Leave : "-"}
              </p>
            </div>

            <div
              onClick={() => navigate("/Emp/EMPLeavesApproval")}
              className="admin-dashboard-card-last dashboard-common-card dashboard-small-card"
            >
              <div className="dashboard-img-icon">
                <MdOutlinePendingActions />
              </div>
              <p className="dashboard-1st-card-heading">Leaves for Approval</p>
              <p className="dashboard-number-heading">
                {pendingLeavesData ? pendingLeavesData : "-"}
              </p>
            </div>
          </div>

          <div className="lower-table-of-admin">
            <div className="EMP-body-part-outer-container">
              <div className="EMP-inner-body-container-of-employee-table row-12">
                <div className="first-side-in-body-header col-6 leave-request-header-mobile">
                  <div className="EMP-employee-text-in-body">
                    <h2>Leave Requests</h2>
                  </div>

                  <div className="dashboard-search-container">
                    <select
                      className="dashboard-search-filter"
                      value={searchFilter}
                      onChange={(e) => setSearchFilter(e.target.value)}
                    >
                      <option value="LeaveTypes">Leave Type</option>
                      <option value="Status">Status</option>
                    </select>

                    <div className="dashboard-search-input-wrapper">
                      <MdSearch className="EMP-search-icon-in-input dashboard-search-icon" />
                      <input
                        type="text"
                        placeholder={`Search by ${
                          searchFilter === "LeaveTypes"
                            ? "Leave Type"
                            : "Status"
                        }`}
                        onChange={(e) => handleDataSearch(e)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="main-class-for-table-in-admin">
                <table className="table-of-employee-leaves table-of-admin desktop-leave-table">
                  <thead className="thead-of-emp-table-leaves">
                    <tr>
                      <th className="approve_Sr">Sr. No.</th>
                      <th className="approve_Date">Date</th>
                      <th className="approve_Type">Leave Type</th>
                      <th className="approve_From">Leave From</th>
                      <th className="approve_To">Leave To</th>
                      <th className="approve_Days">No Of Days</th>
                      <th className="approve_Reason">Employee Reason</th>
                      <th className="approve_Status">Status</th>
                      <th className="approve_Reason">Approval Reason</th>
                      <th className="approve_Date">Action</th>
                    </tr>
                  </thead>

                  <tbody className="tbody-ofemp-table-leaves">
                    {leaveRequest?.length ? (
                      leaveRequest?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            {item?.AppliedDate
                              ? moment(item?.AppliedDate).format("DD MMM YYYY")
                              : "-"}
                          </td>
                          <td>{item?.LeaveTypes?.Name || "-"}</td>
                          <td>
                            {item?.StartDate
                              ? moment(item?.StartDate).format("DD MMM YYYY")
                              : "-"}
                          </td>
                          <td>
                            {item?.EndDate
                              ? moment(item?.EndDate).format("DD MMM YYYY")
                              : "-"}
                          </td>
                          <td>{formatNoOfDays(item?.NumberofDays)}</td>
                          <td title={item?.Reason || ""}>
                            {item?.Reason ? item?.Reason : "-"}
                          </td>
                          <td>
                            <button className={getStatusClassName(item?.Status)}>
                              {item?.Status}
                            </button>
                          </td>
                          <td title={item?.RejectionReason || ""}>
                            {item?.RejectionReason
                              ? item?.RejectionReason
                              : "-"}
                          </td>
                          <td>
                            {item?.Status === "YetToBeApprovedByHR" ||
                            item?.Status === "YetToBeApprovedByAdmin" ? (
                              <>
                                <MdOutlineModeEdit
                                  className="handel-Edit-button"
                                  onClick={() =>
                                    navigate("/Emp/ApplyLeaves", {
                                      state: { leaveRequestData: item },
                                    })
                                  }
                                />
                                <MdDelete
                                  className="handel-delete-button"
                                  onClick={() => handleLeaveDelete(item)}
                                />
                              </>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="no-record-found-tr">
                        <td colSpan="10">No record found</td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <div className="mobile-leave-card-list">
                  {leaveRequest?.length ? (
                    leaveRequest.map((item, index) => {
                      const isExpanded = expandedReasonIndex[index];
                      const reasonText = item?.Reason || "-";
                      const shouldShowToggle = reasonText && reasonText.length > 80;

                      return (
                        <div className="mobile-leave-card mobile-leave-card-small" key={index}>
                          <div className="mobile-leave-card-top">
                            <h4>Request #{index + 1}</h4>
                            <button className={getStatusClassName(item?.Status)}>
                              {item?.Status}
                            </button>
                          </div>

                          <div className="mobile-leave-card-grid">
                            <div className="mobile-leave-field">
                              <span>Applied Date</span>
                              <p>
                                {item?.AppliedDate
                                  ? moment(item?.AppliedDate).format("DD MMM YYYY")
                                  : "-"}
                              </p>
                            </div>

                            <div className="mobile-leave-field">
                              <span>Leave Type</span>
                              <p>{item?.LeaveTypes?.Name || "-"}</p>
                            </div>

                            <div className="mobile-leave-field">
                              <span>Leave From</span>
                              <p>
                                {item?.StartDate
                                  ? moment(item?.StartDate).format("DD MMM YYYY")
                                  : "-"}
                              </p>
                            </div>

                            <div className="mobile-leave-field">
                              <span>Leave To</span>
                              <p>
                                {item?.EndDate
                                  ? moment(item?.EndDate).format("DD MMM YYYY")
                                  : "-"}
                              </p>
                            </div>

                            <div className="mobile-leave-field">
                              <span>No Of Days</span>
                              <p>{formatNoOfDays(item?.NumberofDays)}</p>
                            </div>

                            <div className="mobile-leave-field full-width">
                              <span>Employee Reason</span>
                              <p>
                                {isExpanded ? reasonText : getShortText(reasonText, 80)}
                              </p>

                              {shouldShowToggle && (
                                <button
                                  type="button"
                                  className="read-more-btn"
                                  onClick={() => toggleReadMore(index)}
                                >
                                  {isExpanded ? "Read Less" : "Read More"}
                                </button>
                              )}
                            </div>

                            <div className="mobile-leave-field full-width">
                              <span>Approval Reason</span>
                              <p>{item?.RejectionReason || "-"}</p>
                            </div>
                          </div>

                          {(item?.Status === "YetToBeApprovedByHR" ||
                            item?.Status === "YetToBeApprovedByAdmin") && (
                            <div className="mobile-leave-card-actions">
                              <MdOutlineModeEdit
                                className="handel-Edit-button"
                                onClick={() =>
                                  navigate("/Emp/ApplyLeaves", {
                                    state: { leaveRequestData: item },
                                  })
                                }
                              />
                              <MdDelete
                                className="handel-delete-button"
                                onClick={() => handleLeaveDelete(item)}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div className="mobile-no-record-found">No record found</div>
                  )}
                </div>

                <div></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AdmDashboard;